import React from 'react';
import { Modal as AntdModal } from 'antd';

export const Modal = ({ children, footer = false, ...rest }) => {
    return (
        <AntdModal top={30} footer={footer} {...rest}>
            {children}
        </AntdModal>
    );
};
